import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { a as InternalIcon } from '../Icon/Icon-AcXbY_t4.js';
import { c as check, o as minus } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const hoverMixin = /*#__PURE__*/css(["border-color:", ";background-color:", ";"], ({
  theme
}) => theme.border.color.medium.hover, ({
  theme
}) => theme.selectableWidget.backgroundColor.hover);
const activeMixin = /*#__PURE__*/css(["border-color:", ";background-color:", ";"], ({
  theme
}) => theme.border.color.medium.active, ({
  theme
}) => theme.selectableWidget.backgroundColor.active);
const StyledIcon = /*#__PURE__*/styled(InternalIcon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-13biovi-0"
})(["display:inline-flex;color:", ";"], ({
  theme,
  $disabled
}) => $disabled ? theme.icon.color.unavailable : theme.icon.color.inverted);
const StyledCheckbox = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-13biovi-1"
})(["border:", ";background-color:", ";", " box-sizing:border-box;display:inline-flex;align-items:center;justify-content:center;", ";", ";@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease;}"], ({
  theme
}) => theme.border.medium.default, ({
  theme
}) => theme.selectableWidget.backgroundColor.default, ({
  $size,
  theme
}) => css(["width:", ";height:", ";min-width:", ";min-height:", ";border-radius:", ";"], $size === 'large' ? theme.controls.height.small.default : theme.controls.height.xsmall.default, $size === 'large' ? theme.controls.height.small.default : theme.controls.height.xsmall.default, $size === 'large' ? theme.controls.height.small.default : theme.controls.height.xsmall.default, $size === 'large' ? theme.controls.height.small.default : theme.controls.height.xsmall.default, theme.border.radius.small), ({
  $indeterminate,
  $checked
}) => ($indeterminate || $checked) && css(["border-color:transparent;background-color:", ";"], ({
  theme
}) => theme.selectableWidget.backgroundColor.selected), ({
  $disabled,
  theme
}) => $disabled && css(["border-color:", ";background-color:", ";"], theme.border.color.medium.unavailable, theme.selectableWidget.backgroundColor.unavailable));
const CheckboxIcon = ({
  role,
  size,
  checked,
  indeterminate,
  disabled,
  ...restProps
}) => {
  const iconSize = size === 'large' ? 'medium' : 'base';
  const isMobile = size === 'large';
  return /*#__PURE__*/React__default.createElement(StyledCheckbox, _extends({}, restProps, {
    role: role,
    $size: size,
    $indeterminate: indeterminate,
    $checked: checked,
    $disabled: disabled
  }), checked && /*#__PURE__*/React__default.createElement(StyledIcon, {
    $disabled: disabled,
    type: check,
    size: iconSize,
    isMobile: isMobile
  }), indeterminate && !checked && /*#__PURE__*/React__default.createElement(StyledIcon, {
    $disabled: disabled,
    type: minus,
    size: iconSize,
    isMobile: isMobile
  }));
};

export { CheckboxIcon as C, activeMixin as a, hoverMixin as h };
//# sourceMappingURL=CheckboxIcon-DoWTNtSK.js.map
